import React from 'react';

import Wrapper from '../../../hoc/Wrapper/Wrapper';
import Backdrop from '../Backdrop/Backdrop';

import classes from './Tooltip.module.css';

const tooltip = (props) => {
    //Log(props);
    let stylesClasses = [classes.Tooltip];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            stylesClasses.push(classes[styles[style].trim()]);
        }
    }

    const zIndex = props.zIndex !== undefined ? props.zIndex : 150;

    return (
        <Wrapper>
            <Backdrop visible={props.show} transparent={props.transparentBackdrop} backdropClicked={props.clicked} zIndex={props.zIndex} />
            <div className={stylesClasses.join(' ')}>
                {props.children}
                {props.show
                    ? <div className={classes.Bottom} style={{ zIndex: zIndex }}>
                        {props.content}
                        <i></i>
                    </div>
                    : null}
            </div>
        </Wrapper>
    );
}

export default tooltip;